var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTickBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 2C3.3545455 2 2 3.3545455 2 5L2 19C2 20.645455 3.3545455 22 5 22L19 22C20.645455 22 22 20.645455 22 19L22 11L20 11L20 19C20 19.554545 19.554545 20 19 20L5 20C4.4454545 20 4 19.554545 4 19L4 5C4 4.4454545 4.4454545 4 5 4L14 4L14 2L5 2 z M 20.472656 3.9140625L11.179688 13.765625L7.5078125 10.09375L6.09375 11.507812L11.220703 16.634766L21.927734 5.2871094L20.472656 3.9140625 z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickBox);
export default __webpack_public_path__ + "static/media/tick_box.c7aec07c.svg";
export { ForwardRef as ReactComponent };